import { createSlice } from "@reduxjs/toolkit";

const homeSwitchSlice = createSlice({
  name: "pageSwitch",
  initialState: {
    research: false,
  },
  reducers: {
    showResearch(state) {
      state.research = !state.research;
    },
   
  },
});

export default homeSwitchSlice.reducer;
export const { showResearch } = homeSwitchSlice.actions;
